import React from 'react';
import { ScannerPickImageWithLightbox } from './ScannerPickImageWithLightbox';

/**
 * Текст для рядка «не з замовлення»: завантаження, дані з search-info, помилка.
 */
export function WrongScanDetails({ w }) {
  if (w.resolveStatus === 'loading') {
    return (
      <>
        <div className='text-monospace small font-weight-bold'>{w.barcode}</div>
        <div className='text-muted small mt-1 d-flex align-items-center'>
          <span className='spinner-border spinner-border-sm mr-2' role='status' aria-hidden='true' />
          Перевірка в каталозі…
        </div>
      </>
    );
  }

  if (w.resolveStatus === 'ok' && w.resolvedProduct) {
    const p = w.resolvedProduct;
    return (
      <div className='d-flex align-items-start' style={{ gap: 10 }}>
        <ScannerPickImageWithLightbox imagePath={p.primaryImagePath} alt={p.name} size={52} />
        <div style={{ minWidth: 0 }}>
          <div className='font-weight-bold small' style={{ lineHeight: 1.35 }}>
            {p.name}
          </div>
          <div className='small text-muted mt-1 mb-0'>
            Артикул: <span className='text-monospace'>{p.code || '—'}</span>
          </div>
          <div className='small text-muted mb-0 mt-1'>
            Штрихкод: <span className='text-monospace'>{p.barcode || w.barcode || '—'}</span>
          </div>
        </div>
      </div>
    );
  }

  if (w.resolveStatus === 'not_found') {
    return (
      <>
        <div className='small text-danger font-weight-bold'>Не знайдено в каталозі</div>
        <div className='text-monospace small mt-1'>{w.barcode}</div>
      </>
    );
  }

  if (w.resolveStatus === 'error') {
    return (
      <>
        <div className='small text-danger'>Не вдалося завантажити дані</div>
        <div className='text-monospace small mt-1'>{w.barcode}</div>
      </>
    );
  }

  return <div className='text-monospace small'>{w.barcode}</div>;
}
